// extracted by mini-css-extract-plugin
export default {"attempts":"Attempt_attempts__AqVgR","back":"Attempt_back__NFhgf","selected":"Attempt_selected__A0ltV"};